/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useAuth } from '../../providers/AuthProvider';
import { Join } from '../../components/Home/Join'
import { Prize } from '../../components/Home/Prize';
import { Spacer } from '../../components/Common/Spacer';
import { HowCompete } from '../../components/Home/HowCompete';
import { Winners } from '../../components/Home/Winners';
import { Rules } from '../../components/Rules';
import { FAQ } from '../../components/FAQ';
import { Footer } from '../../components/Common/Footer';
import { DrawerForms } from '../../components/Home/DrawerForms';
import { Box } from '@mui/system';

const PromoContent = styled.div`
  background-image: url('./images/curve-bg-white.png');
  background-color: var(--primary);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: contain;

  @media screen and (max-width: 768px) {
    background-size: auto;
  }
`;

export const Home = () => {
  const { authVerification } = useAuth();

  useEffect(() => {
    let mounted = true;
    if( mounted ) {
      authVerification();
    }
    return () => mounted = false;
  }, []);
  
  return (
    <>
      <Join />
      <PromoContent>
        <Prize />
        <Spacer />
        <HowCompete />
        <Winners />
      </PromoContent>
      <Box mt={2}>
        <Rules />
      </Box>
      <FAQ />
      <Footer />
      <DrawerForms />
    </>
  )
}
